<template>
  <v-data-table
          light
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          :rows-per-page-items="[10, 25, 50]"
          rows-per-page-text="Ítems por página:"
          class="table-text blue-table-header white-text-table-header white-icon dense-table-header"
          disable-initial-sort>
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">{{ props.item.created }}</td>
      <td class="text-xs-left">{{ props.item.approved }}
        <v-tooltip bottom v-if="$store.state.permissions.canViewVencimientos&& isExpired(props.item)">
          <v-icon small color="red lighten-1" class="status-icon" slot="activator">error</v-icon>
          <span>Venció el {{props.item.expiration.date}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="$store.state.permissions.canViewVencimientos && isInTerm(props.item)">
          <v-icon small color="red lighten-1" class="status-icon" slot="activator">calendar_today</v-icon>
          <span>Vence el {{props.item.expiration.date}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="$store.state.permissions.canViewVencimientos && isWithoutTerm(props.item)">
          <v-icon small color="orange lighten-1" class="status-icon" slot="activator">warning</v-icon>
          <span>Vencimiento sin plazo definido</span>
        </v-tooltip>
      </td>
      <td class="text-xs-center" v-if="showSeason">{{ props.item.season }}</td>
      <td v-for="requerimiento in props.item.requirements" :key="requerimiento.pk" class="text-xs-center">
        <v-layout row wrap>
          <v-flex xs8>
            <span>{{ getFormattedData(requerimiento) }}</span>
          </v-flex>
          <v-flex xs4 class="action-buttons">
            <RequerimientoActions :requerimiento="requerimiento" attachments-property-name="attachments" show-images></RequerimientoActions>
          </v-flex>
        </v-layout>
      </td>
      <td class="text-xs-right">
        <CriterioRepositoryOptions :criterio="props.item.pk"
                                   :presentacion="props.item.presentation"
                                   :criterio-comes-from-actualizacion="props.item.criterioComesFromActualizacion">
        </CriterioRepositoryOptions>
      </td>
    </template>

    <template slot="no-data">
      <div class="text-xs-center" v-if="loading">Cargando datos...</div>
      <div class="text-xs-center" v-else>No hay datos disponibles</div>
    </template>
  </v-data-table>
</template>

<script>
import RequerimientoActions from './RequerimientoActions'
import CriterioRepositoryOptions from './CriterioRepositoryOptions'
import { paginationMixin } from '../../../mixins/paginationMixin'
import Constants from '../../../common/constants'

export default {
  mixins: [paginationMixin],

  props: {
    repository: Object
  },

  components: {
    RequerimientoActions,
    CriterioRepositoryOptions
  },

  data () {
    return {
      totalItems: this.repository.totalItems,
      items: this.repository.criteria,
      path: 'repository/' + this.repository.pk,
      currentCriterio: {}
    }
  },

  computed: {
    showSeason () {
      return this.repository.criterionDefinition.showSeason
    },
    headers () {
      let headers = []
      headers.push({ text: 'Fecha presentación', value: 'created', sortable: false })
      headers.push({ text: 'Fecha aprobación', value: 'approved', sortable: false })
      if (this.showSeason) {
        headers.push({ text: 'Temporada', value: 'season', align: 'center' })
      }
      for (let requirementDefinition of this.repository.requirementDefinitions) {
        headers.push({ text: requirementDefinition.nombre, sortable: false, align: 'center' })
      }
      headers.push({ text: 'Acciones', align: 'right', sortable: false })
      return headers
    }
  },

  methods: {
    isExpired (criterio) {
      if (criterio.expiration.hasOwnProperty('allStatus')) {
        return criterio.expiration.allStatus.isExpired
      }
      return false
    },
    isInTerm (criterio) {
      if (criterio.expiration.hasOwnProperty('allStatus')) {
        return criterio.expiration.allStatus.isInTerm
      }
      return false
    },
    isWithoutTerm (criterio) {
      if (criterio.expiration.hasOwnProperty('allStatus')) {
        return criterio.expiration.allStatus.isWithoutTerm
      }
      return false
    },
    setItems (responseData) {
      this.items = responseData.results.criteria
    },
    getFormattedData (requirement) {
      if (requirement.tipo === Constants.REQUERIMIENTO_HAS_BOOLEAN) {
        return requirement.data ? 'Sí' : 'No'
      }
      return requirement.data
    }
  }
}
</script>

<style scoped>
  .table-text {
    font-family: SourceSansProRegular, sans-serif;
  }
</style>
